<style lang="scss">
    .alert-error {
        color: #721c24;
        background-color: #f8d7da;
        border: 1px solid #f5c6cb;
    }

    .alert-success {
        color: #155724;
        background-color: #d4edda;
        border: 1px solid #c3e6cb;
    }

    .alert {
        position: relative;
        padding: .75rem 1.25rem;
        margin-bottom: 1rem;
        border-radius: .25rem;
    }
</style>

<template>
    <div class="alert"
         :class="{
         'alert-error' : color === 'red' ,
         'alert-success' : color === 'green'}"
         role="alert">
            {{message}}
    </div>
</template>

<script>
    export default {
        name: "Alert",
        props: {
            message: {
                type: String,
                default: ""
            },
            color: {
                type: String,
                default: ""
            }
        }
    }
</script>

